import { on, get } from '@bigyouth/base'

import setAttributes from '../utils/setAttributes'
import removeAttributes from '../utils/removeAttributes'
import { create as createPipe } from '../utils/sigpipe'
import scrollManager from '../utils/scrollManager'

export const ACTIONS = {
  CLOSE: 'POPIN_CLOSE',
  OPEN: 'POPIN_OPEN',
}



const CONTENT_SELECTOR = '.app'

/**
 * Popin will send the corresponding dom node in the .popins layer and create a pipe for future
 * interactions.
 *
 * You can get the pipe with the id injected as an attribute on the dom node (data-pipe-id) and
 * control the popin with the actions specified above.
 */
export default {
  name: 'popin',

  ui: {
    'closeButton[]': '[js-popin-close]',
  },

  events: [
    {
      on: 'click',
      target: 'closeButton',
      handle: 'handleClose',
    },
    {
      on: 'click',
      handle(e) {
        // if click on overlay, close popin
        if (e.target === this.el) {
          this.handleClose()
        }
      },
    },
  ],

  componentDidMount() {
    this.mainContent = get(CONTENT_SELECTOR)

    get('.popins').appendChild(this.el)

    // Create pipe for future communications
    this.pipe = createPipe()
    setAttributes({ dataPipeId: `${this.pipe.id}` })(this.el)

    this.pipe.on(({ action, emitterEl }) => {
      this.emitterEl = emitterEl

      switch (action) {
        case ACTIONS.OPEN:
          this.handleOpen()
          break

        case ACTIONS.CLOSE:
          this.handleClose()
          break
      }
    })

    // Event listener for closing on Escape key
    this.offEscape = on('keyup', (event) => {
      if (event.key === 'Escape') {
        this.handleClose()
      }
    })(document.body)
  },

  componentWillUnmount() {
    this.pipe.destroy()

    this.offEscape()

    removeAttributes('js-sr-inactive')(this.mainContent)
  },

  handleOpen() {
    if (!this.el.classList.contains('is-hidden')) return

    this.el.classList.remove('is-hidden')

    // Disabled scrolling on main content
    setTimeout(scrollManager.stop, 0)

    removeAttributes('js-sr-inactive')(this.el)
    setAttributes({ 'js-sr-inactive': '' })(this.mainContent)
  },

  handleClose() {
    if (this.el.classList.contains('is-hidden')) return

    this.el.classList.add('is-hidden')

    setAttributes({ 'js-sr-inactive': '' })(this.el)
    removeAttributes('js-sr-inactive')(this.mainContent)

    scrollManager.restart()

    if (this.emitterEl) this.emitterEl.focus({ preventScroll: true })
  },
}
